import axiosInstance from '../../axios-config';

const getMedicalNotesUrl = '/api/patients/{0}/medicalnotes/published';
const getNewMedicalNotesCountUrl = '/api/patients/{0}/medicalnotes/notReviewedCount';
const updateMedicalNoteAsReviewedUrl = '/api/patients/{0}/medicalnotes/{1}/setasreviewed';
const getMedicalNotePageUrl = '/api/patients/{0}/medicalnotes/published/{1}/page/{2}/content?token={3}';

export const getMedicalNotes = (patientId) => axiosInstance.get(getMedicalNotesUrl.replace('{0}', patientId));

export const getNewMedicalNotesCount = (patientId) =>
  axiosInstance.get(getNewMedicalNotesCountUrl.replace('{0}', patientId));

export const updateMedicalNoteAsReviewed = (patientId, medicalNoteId) =>
  axiosInstance.post(updateMedicalNoteAsReviewedUrl.replace('{0}', patientId).replace('{1}', medicalNoteId));

export const medicalNotePageUrl = (patientId, medicalNoteId, pageNumber, token) =>
  axiosInstance.defaults.baseURL +
  getMedicalNotePageUrl
    .replace('{0}', patientId)
    .replace('{1}', medicalNoteId)
    .replace('{2}', pageNumber)
    .replace('{3}', token);